// Contagem de convites de clínica pendentes do médico logado. Alimenta o
// contador do item "Clínicas" da sidebar e o aviso do dashboard.
import { DoctorClinics } from "@/services/doctor_clinics";

export const state = {
  pendingCount: 0
};

export const mutations = {
  SET_PENDING_COUNT(state, count) {
    state.pendingCount = count;
  }
};

export const getters = {
  pendingCount: state => state.pendingCount
};

export const actions = {
  async refresh({ commit }) {
    try {
      const { data, headers } = await DoctorClinics.invitations();
      const total = Number((headers || {})["total-count"]);
      commit(
        "SET_PENDING_COUNT",
        Number.isFinite(total) && (headers || {})["total-count"] != null
          ? total
          : (data || []).length
      );
    } catch (e) {
      // contador é acessório: sem rede, mantém o último valor conhecido
    }
  }
};
